import moment from 'moment';

import { DEFAULT_LANG } from '@rover/constants/src/i18n/language';
import { I18N_FORMAT_MAP } from '@rover/kibble/styles';
import type { Day } from '@rover/types';
import { DateRangeField } from '@rover/types/src/datetime/DateRange';

const getDateAtNoon = (date?: Date): Date | undefined =>
  date && new Date(new Date(date).setHours(12, 0, 0, 0));

const parseDate = (
  value: string | Date | undefined,
  language: string
): string | Date | undefined => {
  if (!value || value instanceof Date) {
    return value;
  }

  const date = moment(value, [
    I18N_FORMAT_MAP[language].DATE_SHORT,
    I18N_FORMAT_MAP[language].DATE_ISO || I18N_FORMAT_MAP[DEFAULT_LANG].DATE_ISO,
  ]).toDate();

  const dateAtNoon = getDateAtNoon(date);

  return dateAtNoon;
};

export const parseDateToString = (value?: DateRangeField): string | null => {
  // Parse date to string in format YYYY-MM-DD, e.g. 2020-01-01 (used mostly for analytics).
  if (!value) return null;
  return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`;
};

export default parseDate;

export const parseServiceDates = (value: Day[]): string | null => {
  if (!value || !value.length) return null;
  const daysOfWeek = value.map((day) => day.name);
  return daysOfWeek.join(', ');
};
